import themeDark from 'assets/theme-dark';
import styled from 'styled-components';

export const FileUploadContainer = styled.section`
  position: relative;
  margin: 1.2rem 0 0.5rem;
  border: 2px dotted lightgray;
  padding: 1rem 0.5rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${themeDark.palette.background.card};
`;

export const FormField = styled.input`
  font-size: 18px;
  display: block;
  width: 100%;
  border: none;
  text-transform: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;

  &:focus {
    outline: none;
  }
`;

export const InputLabel = styled.label`
  top: -21px;
  font-size: 0.8rem;
  color: ${themeDark.palette.text.main};
  left: 0;
  position: absolute;
`;

export const DragDropText = styled.p`
  font-weight: bold;
  letter-spacing: 1.2px;
  margin-top: 0;
  text-align: center;
  font-size: 1.1rem;
  color: ${themeDark.palette.secondary.main};
`;

export const ErrorText = styled.p`
  font-weight: bold;
  font-size: 1rem;
  color: red;
  line-height: 0.9rem;
  margin: 0 0 0.5rem 0;
`;

export const UploadFileBtn = styled.button`
  box-sizing: border-box;
  appearance: none;
  background-color: transparent;
  border: 2px solid ${themeDark.palette.badgeColors.info.background};
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  padding: 0.5rem 2.8rem;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 6px;
  color: ${themeDark.palette.badgeColors.info.background};
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: color 250ms ease-in-out;
  font-family: 'Open Sans', sans-serif;
  width: 45%;
  display: flex;
  align-items: center;
  padding-right: 0;
  justify-content: center;

  &:after {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 100%;
    background: #3498db;
    z-index: -1;
    transition: width 250ms ease-in-out;
  }

  svg {
    width: 2.5rem;
    height: auto;
    margin-right: 0.5rem;
  }

  @media only screen and (max-width: 500px) {
    width: 70%;
    font-size: 0.8rem;
  }

  @media only screen and (max-width: 350px) {
    width: 100%;
    font-size: 0.6rem;
  }

  &:hover {
    color: #fff;
    outline: 0;
    background: transparent;

    &:after {
      width: 110%;
    }
  }

  &:focus {
    outline: 0;
    background: transparent;
  }

  &:disabled {
    opacity: 0.4;
    filter: grayscale(100%);
    pointer-events: none;
  }
`;

export const FilePreviewContainer = styled.article`
  margin-bottom: 0.5rem;
  span {
    font-size: 0.8rem;
    color: ${themeDark.palette.text.main};
  }
`;

export const PreviewList = styled.section`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;

  @media only screen and (max-width: 400px) {
    flex-direction: column;
  }
`;

export const FileMetaData = styled.div`
  display: ${(props) => (props.isImageFile ? 'none' : 'flex')};
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px;
  border-radius: 6px;
  color: white;
  font-weight: bold;
  background-color: rgba(5, 5, 5, 0.55);

  aside {
    margin-top: auto;
    display: flex;
    justify-content: space-between;

    svg {
      cursor: pointer;

      &:hover {
        transform: scale(1.3);
      }
    }
  }
`;
export const PreviewContainer = styled.section`
  padding: 0.25rem;
  width: 20%;
  height: 120px;
  border-radius: 6px;
  box-sizing: border-box;

  &:hover {
    opacity: 0.55;

    ${FileMetaData} {
      display: flex;
    }
  }

  & > div:first-of-type {
    height: 100%;
    position: relative;
  }

  @media only screen and (max-width: 750px) {
    width: 25%;
  }

  @media only screen and (max-width: 500px) {
    width: 50%;
  }

  @media only screen and (max-width: 400px) {
    width: 100%;
    padding: 0 0 0.4em;
  }
`;

export const ImagePreview = styled.img`
  width: ${(props) => (props.isIcon ? 'auto' : '100%')};
  border-radius: 6px;
  height: ${(props) => (props.isSmall ? '50%' : '100%')};
  margin: ${(props) => (props.isSmall ? '20% 10%' : '0 33%')};
  @media (max-width: 768px) {
    width: ${(props) => (props.isIcon ? 'auto' : '100%')};
    height: 60%;
    margin: 20% 20%;
  }
`;
